import polyglotI18nProvider from 'ra-i18n-polyglot'

import * as Messages from './locales'

// TODO: Make changing locale at runtime
export default polyglotI18nProvider(locale => Messages[locale], 'en')
